const keeSearch = ({
    userGroup = 1,
    showIfNoSearch = false,
    showOnFocus = false,
    searchBox = {
      container: '#searchbox',
      cssClasses: { input: 'form-control' },
    },
    defaultQuery = false,
    ...instantsearchArgs
  }) => {

  const _showOnFocus = () => {
    $('body').on('focus', '.ais-SearchBox-input', function() {
      showIfNoSearch = true;
      search.helper.search();
    });
  }

  if ( showOnFocus ) {
    _showOnFocus();
  }

  const { algoliasearch, instantsearch } = window;
  const fallbackImage = "https://cdn.neto.com.au/assets/neto-cdn/images/default_product.gif";

  const algoliaClient = algoliasearch('GXRPP7EBIT', '08ea5d39af949cb6cccd2b7c383ca5a1');
  const searchClient = {
    ...algoliaClient,
    search(requests) {
      if (!showIfNoSearch && requests.every(({ params }) => !params.query)) {
        return Promise.resolve({
          results: requests.map(() => ({
            hits: [],
            nbHits: 0,
            nbPages: 0,
            page: 0,
            processingTimeMS: 0,
          })),
        });
      }

      return algoliaClient.search(requests);
    },
  }

  const search = instantsearch({
    indexName: 'swe',
    searchClient,
    ...instantsearchArgs,
    insights: true,
  });


  const user_group = userGroup ? parseInt(userGroup) : 1;

  const formatMoney = (amount, rounded = false, currency = 'AUD', locale = 'en-AU') => {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: rounded ? 0 : 2,
      maximumFractionDigits: rounded ? 0 : 2
    }).format(amount);
  };

  // Render function so we can control the "View All" buttons
  const renderHits = (renderOptions) => {
    const { hits, sendEvent, widgetParams } = renderOptions;
    const { templates, container, title, searchUrl } = widgetParams;

    document.querySelector(container).innerHTML = `
    <div class="hits__header mb-3">
      ${hits.length ? `<a href="${searchUrl}${search.helper.state.query}" class="hits__header__viewall btn-view-all">View All</a>`: ""}
      <h3>${title}</h3>
    </div>
    ${ hits.length ? `
      <div class="ais-Hits">
        <ol class="ais-Hits-list">
          ${hits
            .map(
              hit =>
                `<li class="ais-Hits-item">
                ${templates.item(hit)}
                </li>`
            )
            .join('')}
        </ol>
      </div>
      <a href="${searchUrl}${search.helper.state.query}" class="btn btn-block btn-blank btn-view-all">View All</a>
    ` :
    `<p class="mb-3">${search.status === 'loading' ? 'Loading...' : search.status === 'stalled' ? 'Still loading...' : 'No Results Found'}</p>`}
    `;

    document.querySelectorAll('#hits-swe .addtocart').forEach((element, index) => {
      element.addEventListener('click', () => {
        sendEvent('conversion', hits[index], 'Added to Cart', {
          eventSubtype: 'addToCart'
        });
      });
    });

  };

  // 2. Create the custom widget
  const { connectHits, connectInfiniteHits } = instantsearch.connectors;
  const customHits = connectHits(renderHits);

  const swe_hit_template = {
    item(hit) {
      const price = hit['price_groups'][user_group];
      const needsToBeLoggedIn = hit.loggedin_only == 'y' && (user_group == 7 || user_group == 1);
      const canOrder = !hit.track_inventory || (!needsToBeLoggedIn && hit.buttonText === 'Shop Now');

      if (!hit.track_inventory) {
        hit.buttonText = 'Shop Now';
      }

      return `
      <div class="card mb-4">
        <a href="${hit.item_url}?queryID=${hit.__queryID}" class="thumbnail-image text-center">
          <img width=270 height=270 src="${hit.thumbnail_url || fallbackImage}" alt="${hit.name}" class="card-img-top" />
        </a>
        <div class=" card-body">
          <h4 class="card-title 3">
            <a href="${hit.item_url}?queryID=${hit.__queryID}" title="${hit.name}">
              ${instantsearch.highlight({ hit, attribute: 'name' })}
            </a>
          </h4>

          ${!needsToBeLoggedIn && hit.rrp && hit.rrp > price ? `
            <div class="search_price_main mb-3">
              Why Pay <s class="price-for-discount">${formatMoney(hit.rrp)}</s>
            </div>
          `: ``}

          ${!needsToBeLoggedIn ? `<div class="search_price_main mb-3">
            Now <span class="price-main price-to-update">${formatMoney(price)}</span>
            ${hit.rrp && hit.rrp > price ? `
              <span class="badge badge-primary badge-save ml-2" style="padding: 5px 5px;font-size: 12px;float: right;">Save <span class="discount-to-update">${formatMoney(hit.rrp - price)}</span></span>
          `: ``}
          </div>` :``}

          <form class="buying-options">
            <input type="hidden" id="sku${hit.upc}" name="sku${hit.upc}" value="${hit.upc}" />
            <input type="hidden" id="model${hit.upc}" name="model${hit.upc}" value="${hit.name}" />
            <input type="hidden" id="thumb${hit.upc}" name="thumb${hit.upc}" value="${hit.thumbnail_url}" />
            <input type="hidden" id="qty${hit.upc}" name="qty${hit.upc}" value="1" />
            ${canOrder ?
              `<button type="button" class="addtocart btn-accent-color-1 btn btn-block btn-loads btn-search-atc" rel="${hit.upc}" data-loading-text="<i class='fa fa-spinner fa-spin' style='font-size: 14px'></i>">${hit.buttonText}</button>`
              :
              `<a href="${hit.item_url}" class="btn btn-accent-color-1 btn-block btn-loads btn-search-result">
                ${needsToBeLoggedIn ?
                  `More Information`: hit.buttonText
                }
              </a>`}
          </form>

        </div>
      </div>
      `;
    }
  };

  search.addWidgets([
    instantsearch.widgets.searchBox(searchBox),

    // SWE search
    instantsearch.widgets
      .index({ indexName: 'swe', insights: true })
      .addWidgets([
        instantsearch.widgets.configure({
          filters: `user_group:${user_group}`,
          hitsPerPage: 4,
        }),
        customHits({
          container: '#hits-swe',
          title: "Parts & Accessories",
          searchUrl: "https://shop.spaworld.com.au/?rf=kw&kw=",
          templates: swe_hit_template,
        }),
      ]),

    // SWAU Blog search
    instantsearch.widgets
      .index({ indexName: 'swau-global-learn' })
      .addWidgets([
        instantsearch.widgets.configure({hitsPerPage: 4}),
        customHits({
          container: '#hits-learn',
          title: "Learn",
          searchUrl: "https://www.spaworld.com.au/search-results/?search_type=swau-global-learn&query=",
          templates: {
            item(hit) {
              const isVideo = hit.video;
              const url = isVideo ? hit.video.url : "https://www.spaworld.com.au" + hit.url;

              return `
              <div class="card mb-4">
                <a href="${url}" style="position: relative;background-color: #005a8b;height: 140px;overflow: hidden; text-align: center">
                  ${hit.image ? `
                    <img width="500" height="265" style="height:auto; width: 100%" class="card-img-top" src="${hit.image.url}&h=265&q=60&w=500" alt="${hit.name}" />
                  ` : `<svg style="height: 100%" viewBox="0 0 79 81"><g fill="none" fill-rule="evenodd"><path d="M78.8 39.8a39.5 39.5 0 11-79 .2 39.5 39.5 0 0179-.2" fill="#00588D"></path><path d="M30.3 16.9a5.3 5.3 0 00-4.4-1.5l-1.9.3-1 .2c-2.6.7-5 1.8-7.1 3.5a13 13 0 00-3.5 3.8c-.4.7-.7 1.5-.8 2.4-.1 1.4.3 2.7 1.3 4a15 15 0 003.4 2.8l3.4 2 2.7 1.7c.7.5 1.4 1.2 2 2 1 1.3 1.3 2.7 1.1 4.3-.2 1.5-.8 3-2 4.6a19.4 19.4 0 01-8.7 6.1c-.4.2-.6 0-.7-.1l-.3-.4-.6-.8c-.6-1.1-1-2.5-1-4 0-1.8.2-3.5.7-5.1.2-.7.1-1.1-.6-1.5-.5-.2-1-.4-1.5-.4-.7-.2-1.4.1-1.7.8a15 15 0 00-.9 1.8c-.4 1.4-.7 2.9-.7 4.6a7.4 7.4 0 005.4 7.5A10 10 0 0020 55c2.2-1 4.2-2.3 6.2-4 1.8-1.7 3.1-3.6 4-5.7.5-1.4.6-3 .2-4.5-.3-1.3-1-2.6-2.1-3.7-1-1.1-2.3-2.2-3.9-3l-4-2.5c-1.1-.5-2-1.2-2.8-2-1.2-1-1.4-2.2-.8-3.7l1-1.7c1.1-1.5 2.7-2.7 5.2-4a10.8 10.8 0 013-1l-.2 2.1v.4c-.1 1.7-.3 3.3-.1 5 0 .6.2 1.4.5 2 .7 1.4 2 2.2 3.9 2.5h.9c.3 0 .5-.2.6-.5v-.6l-.6-.6c-.4-.3-.5-.8-.6-2 0-1.8 0-3.5.3-5.1l.1-1.8.2-1.8a2 2 0 00-.7-2m22.5 13.4a4 4 0 00-2.3-2.8 5 5 0 00-4.6.4 9.2 9.2 0 00-3.4 3.1c-.8 1.1-1.4 2.3-2 3.6-.8 1.6-1.4 3.2-2 4.8L37.4 42l.3-2.1.6-5c0-1.4 0-2.7-.4-4-.5-1.4-1.1-2.2-2.3-2.7l-.7-.2c-.4 0-.5.1-.6.3v.5c.2.5.3 1 .2 1.8 0 1 0 2.1-.3 3.4-.3 1.4-.6 3.7-1 5 0 .7-.2 1.4-.3 2l-2 10.2c-.4 2.5-.8 4.8-1 7.2-.1 1-.2 2.1 0 3.2.1.9 1.2 1.4 2 1.4 1 0 1.2-.2 1.5-1l.6-2 1.8-6.6 1.1-3.8a101.6 101.6 0 017.3-17.1c1-1.5 2-2.5 3.3-3.2.6-.2 1-.3 1.1-.2.2 0 .2.6.3 1.2v.1c0 4.5-2.6 11.5-6.4 14.4-.5.3-.9.4-1.3 0l-.6-.3h-.8c-.4 0-.6.3-.7.4 0 .2-.1.4 0 .8.4.5.8.9 1.4 1.1 3 1.4 6.7-.6 8.6-3.3 2-3.3 3.4-6.8 3.8-10.4a8 8 0 000-3M72.3 35a1 1 0 00-1.3 0l-.4.6-1.6 2.6a16 16 0 01-2.8 3.2V41l1.3-5.2.2-.5.8-2.7c.2-.7 0-1.4-.7-1.8-.6-.4-1-.6-1.6-.7-.6 0-1.1 0-1.5.6l-.3.5-2.5 5a20.8 20.8 0 01-5 6.5l-.1-.2v-1.4c.3-2.5 1-4.9 2.2-7 1-1.9 2-3.3 3.4-4.5.9-.7 1.6-1.2 2.5-1.4.7-.2 1.4-.3 2 .2h.9V28l-.3-.6a4.4 4.4 0 00-3.7-1.5c-1.2 0-2.3.5-3.4 1.3-1.3 1-2.4 1.9-3.1 2.9a19.3 19.3 0 00-3.3 6.2c-.4 1.3-.9 2.9-.7 4.4v.7A4 4 0 0057 45c.7 0 1.4-.2 1.9-.7l1.4-1.6 1.8-2.6v.4c.3 1.7 1 2.9 3.2 3.4.8.2 1.6 0 2.2-.5a29.2 29.2 0 003.3-4.4c.5-.9 1.2-1.9 1.5-3 .2-.2.3-.6 0-1" fill="#FEFEFE"></path><path fill="#FEFEFE" d="M48 51.5l-1.8 5.7h-.9L43.7 53l-1.5 4.2h-.9l-1.8-5.7h1l1.4 4.3 1.4-4.3h.9l1.5 4.3 1.3-4.3zM51 57.2c-.4 0-.8 0-1.1-.2a2.8 2.8 0 01-1.4-1.6 3 3 0 01.6-3c.2-.3.5-.6.8-.7.4-.2.7-.3 1.1-.3.4 0 .8.1 1.1.3a2.8 2.8 0 011.4 1.6 3 3 0 01-1.4 3.7l-1.1.2m-1.8-2.9a2.4 2.4 0 00.5 1.5l.5.4.8.2c.3 0 .5 0 .8-.2l.5-.5.4-.6a2.4 2.4 0 000-1.6 2 2 0 00-.4-.6c-.2-.2-.3-.4-.6-.5l-.7-.1-.8.1-.5.5-.4.7-.1.7m5.4 2.9v-5.7h2.5l.7.1.5.5a2 2 0 01.5 1.2 2 2 0 01-.3 1c0 .2-.2.4-.3.5l-.5.2 1.4 2.2h-1l-1.3-2h-1.3v2h-.9zm1-2.8h1.8l.3-.3.2-.4a1.3 1.3 0 000-.8l-.2-.3a1 1 0 00-.3-.2l-.4-.1h-1.5v2.1zM59.9 57.2v-5.7h.9v4.9h3v.8zm4.6 0v-5.7h2c.5 0 .9 0 1.2.2a2.5 2.5 0 011.4 1.5l.2 1.1c0 .4 0 .8-.2 1.2l-.5.9-1 .6a3 3 0 01-1 .2h-2zm3.9-2.9l-.1-.8-.4-.7-.6-.4a2 2 0 00-.8-.1h-1v4h1.8l.6-.5.4-.7v-.8z"></path></g></svg>`}
                  ${isVideo? `<button style="background: none;border: none;border-radius: 50rem;cursor: pointer;inset: 0;line-height: 0;padding: 0;position: absolute;width: 100%;">
                    <svg style="height: 2em;position: relative;width: 2em;z-index: 3;" viewBox="0 0 45 45"><g fill="none" fill-rule="evenodd"><circle fill="#E10E49" cx="22.5" cy="22.5" r="22.5"></circle><path fill="#FFF" d="M31 22.5L18 30V15z"></path></g></svg>
                  </button>`: ``}
                </a>
                <div class=" card-body">
                  <h4 class="card-title mb-4">
                    <a href="${url}" title="${hit.name}">
                      ${instantsearch.highlight({ hit, attribute: 'name' })}
                      </a>
                  </h4>
                  <a href="${url}" class="btn btn-accent-color-2 btn-block btn-loads">
                    ${isVideo ? `Watch` : `Read More`}
                  </a>
                </div>
              </div>
              `;
            }
          }
        })
      ]),

    // SWAU search
    instantsearch.widgets
      .index({ indexName: 'swau-global-products' })
      .addWidgets([
        instantsearch.widgets.configure({
          //filters: `tags:"All Products"`,
          hitsPerPage: 4,
        }),
        customHits({
          container: '#hits-swau',
          title: "Spas & More",
          searchUrl: "https://www.spaworld.com.au/search-results/?search_type=swau-global-products&query=",
          templates: {
            item(hit) {
              return `
              <div class="card mb-4">
                <a href="https://www.spaworld.com.au${hit.url}" class="thumbnail-image text-center py-2 px-4" style="background:#F1F1F1">
                  <img src="${(hit.image ? hit.image + '&h=265&q=60&w=500&fill=solid&fill-color=00ffffff&fit=fill' : false) || fallbackImage}" alt="${hit.name}" class="card-img-top" />
                </a>
                <div class="card-body">
                  <h4 class="card-title h4 mb-3">
                    <a href="https://www.spaworld.com.au${hit.url}" title="${hit.name}">
                      ${instantsearch.highlight({ hit, attribute: 'name' })}
                    </a>
                  </h4>
                  <div class="search_price_main">
                    ${hit.salePrice && `From <strong>${formatMoney(hit.salePrice, true)}</strong>`}
                  </div>
                </div>

                ${hit.finance ? `
                  <div class="search__finance">
                      <div class="search__finance_provider">
                          <div class="search__finance_provider__wrapper">
                              <div style="max-width: 22px; display: block;">
                                  <img src="${hit.finance[0].logo.url}&amp;dpr=2&amp;fill=solid&amp;fill-color=00ffffff&amp;fit=fill&amp;h=22&amp;q=60&amp;w=22" width="22" height="22" />
                              </div>
                              <h5 class="m-0">${hit.finance[0].name}</h5>
                          </div>
                      </div>
                  </div>

                ` : ``}
              </div>
              `;
            }
          },
        }),
      ]),
  ]);

  // Tracking
  function debounce(fn, delay) {
    let timeoutID = null;

    return function (...args) {
      clearTimeout(timeoutID);
      timeoutID = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  let zohoTracked = false;
  function pagesenseMiddleWare() {
    return {
      onStateChange() {
        if (zohoTracked) {
          return;
        }
        zohoTracked = true;

        window.pagesense = window.pagesense || [];
        window.pagesense.push(['trackActivity', 'search']);
      },
      subscribe() {},
      unsubscribe() {},
    };
  }

  function gtmMiddleWare() {
    window.dataLayer = window.dataLayer || [];

    const sendEventDebounced = debounce(() => {
      dataLayer.push({
        'event': 'search',
        'search_term': search.helper.state.query
      });
    }, 1000);

    return {
      onStateChange() {
        sendEventDebounced();
      },
      subscribe() {},
      unsubscribe() {},
    };
  }

  // Query ID
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;
  const queryID = searchParams.get("queryID");
  if (queryID) {
      localStorage.setItem("queryID", queryID);
  }

  // "View All" page
  if (document.getElementById('swe-viewall')) {

    let $loadMoreButton = false;
    const renderHitsViewAll = (renderOptions, isFirstRender) => {
      const { hits, widgetParams, showMore, isLastPage } = renderOptions;
      const { templates, container } = widgetParams;

      const $container = document.querySelector(container);
      let status = search.status;

      if (isFirstRender) {
        $loadMoreButton = document.createElement('div');
        $loadMoreButton.className = 'row';
        $loadMoreButton.innerHTML = "<div class='col text-center'><button class='btn btn-accent-color-2'>Load More</button></div>"

        $loadMoreButton.addEventListener('click', () => {
          showMore();
        });

        $container.insertAdjacentElement('afterend', $loadMoreButton);

        status = 'loading';
      }

      $loadMoreButton.style.display = isLastPage ? 'none' : '';

      $container.innerHTML = `
      ${ hits.length ? `
          <section class="row products-row row-cols-1 row-cols-xxs-2 row-cols-xl-3 row-cols-xxl-4 mb-4" style="row-gap: 10px">
            ${hits
              .map(
                hit =>
                  `<article class="col " role="article" aria-label="Product thumbnail">
                  ${templates.item(hit)}
                  </article>`
              )
              .join('')}
          </section>
      ` :
      `<p class="mb-3">${status === 'loading' ? 'Loading...' : status === 'stalled' ? 'Still loading...' : 'No Results Found'}</p>`
      }
      `;
    };

    const customHitsViewAll = connectInfiniteHits(renderHitsViewAll);
    const viewAllSearch = instantsearch({
      indexName: 'swe',
      searchClient: algoliaClient,
      initialUiState: {
        swe: {
          query: defaultQuery
        },
      },
    });
    viewAllSearch.addWidgets([
      instantsearch.widgets.searchBox({
        container: '#viewall-searchbox',
        cssClasses: { input: 'form-control' }
      }),

      // SWE search
      instantsearch.widgets
        .index({ indexName: 'swe' })
        .addWidgets([
          instantsearch.widgets.configure({
            filters: `user_group:${user_group}`,
            hitsPerPage: 12,
            /*query: defaultQuery*/
          }),
          customHitsViewAll({
            container: '#viewall-swe',
            templates: swe_hit_template
          }),
        ]),
      ]);

      viewAllSearch.use(gtmMiddleWare);
      viewAllSearch.use(pagesenseMiddleWare);
      viewAllSearch.start();
  }

  search.use(gtmMiddleWare);
  search.use(pagesenseMiddleWare);

  search.start();

  return {
    search,
    showOnFocus: _showOnFocus
  };
};


$(document).ready(function() {
  $('#swe-search').on('click', 'a', function(event) {

    const vimeoPattern = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/.*/;
    const href = $(this).attr('href');

    if (vimeoPattern.test(href)) {
      event.preventDefault();
      const vimeoEmbedUrl = `https://player.vimeo.com/video/${href.split('/').pop()}?autoplay=1`;

      const modalTemplate = `
        <div class="modal fade" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="embed-responsive embed-responsive-16by9">
                  <iframe class="embed-responsive-item" src="${vimeoEmbedUrl}" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;

      const $modal = $(modalTemplate);
      $('body').append($modal);
      $modal.modal('show');

      $modal.on('hidden.bs.modal', function() {
        $(this).remove();
      });
    }
  });
});
